var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m5.374 31.29 3.816-2.203a1 1 0 0 1 .684-.117l7.509 1.406a1 1 0 0 0 1.184-.988l-.03-6.58a1 1 0 0 1 .137-.508l3.79-6.488a1 1 0 0 0-.046-1.079l-6.38-9.082M38 9.718C27 15 33 22 35 23c3.755 1.877 8.975 2 8.975 2q.025-.497.025-1c0-11.046-8.954-20-20-20S4 12.954 4 24s8.954 20 20 20q.503 0 1-.025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M34.323 31.56c-1.666-1.922-4.442-2.439-6.528-.678-2.087 1.76-2.38 4.703-.742 6.786 1.015 1.29 3.563 3.645 5.354 5.252.658.59.987.884 1.382 1.003.339.102.728.102 1.067 0 .395-.119.724-.413 1.382-1.003 1.791-1.607 4.339-3.962 5.354-5.252 1.638-2.083 1.38-5.045-.742-6.786-2.122-1.742-4.862-1.244-6.528.679",
    clipRule: "evenodd"
  })));
};
export default SvgWorld;